import {Component, OnInit, ViewChild, ViewEncapsulation} from "@angular/core";
import {FuseAlertComponent} from "@fuse/components/alert";
import {NgForOf, NgIf} from "@angular/common";
import {fuseAnimations} from "@fuse/animations";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MultiAlertService} from "app/core/services/multi.alert.service";
import {MatProgressBar} from "@angular/material/progress-bar";


@Component({
    selector     : 'multi-alert',
    templateUrl  : './multi.alert.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    animations: [fuseAnimations],
    imports: [
        FuseAlertComponent,
        NgIf,
        MatButton,
        MatIcon,
        NgForOf,
        MatProgressBar
    ]
})
export class MultiAlertComponent implements OnInit
{
    @ViewChild("progressBar") progressBar: MatProgressBar;

    /**
     * Constructor
     */
    constructor(
        protected _multiAlertService: MultiAlertService,
    )
    {}

    ngOnInit() {

    }

    handleCloseEvent($event, alertID:number){
        this._multiAlertService.dismiss(alertID);
    }
}
